import React from 'react';
import { useIsFullyExpanded } from '../../../controllers/is-fully-expanded/index.tsx';
import { withNestingOptimisation } from '../with-nesting-optimisation/index.tsx';
import type { QuickstartNudgeProps } from './types.tsx';

export const QuickstartNudge = withNestingOptimisation<QuickstartNudgeProps>(
	({ renderWrapper, children }: QuickstartNudgeProps) => {
		const isFullyExpanded = useIsFullyExpanded();

		return isFullyExpanded ? renderWrapper(children) : <>{children}</>;
	},
);
